<template>
  <layout-horizontal>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <app-navbar-horizontal-layout-brand v-if="false" />
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <sidebar-control-escolar
      v-if="$store.state.cuenta.session.token && (userRol.id === 2 || userRol.id === 3 || userRol.id === 9 || userRol.id === 11)"
      slot="customizer"
    />
  </layout-horizontal>
</template>

<script>
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
import SidebarControlEscolar from '@core/layouts/components/sidebar-control-escolar/SidebarControlEscolar.vue'
import AppNavbarHorizontalLayoutBrand from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayoutBrand.vue'
import { rolesActions } from '@core/mixins/account-data/roles'
import Navbar from '../components/Navbar.vue'

export default {
  components: {
    LayoutHorizontal,
    SidebarControlEscolar,
    Navbar,
    AppNavbarHorizontalLayoutBrand,
  },
  mixins: [rolesActions],
}
</script>
